import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { HttpService } from '../http.service';
import { SnackbarService } from '../snackbar.service';
import { DateTime } from "luxon";
import { MatDialog, MatPaginator ,PageEvent} from '@angular/material';
import { EventService } from '../event.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { JsplDetailsViewComponent } from '../jspl-details-view/jspl-details-view.component';

@Component({
  selector: 'app-closed-trips-details',
  templateUrl: './closed-trips-details.component.html',
  styleUrls: ['./closed-trips-details.component.scss']
})
export class ClosedTripsDetailsComponent implements OnInit {

  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("addRemarkDialog", { static: true }) addRemarkDialog: TemplateRef<any>;
  @ViewChild("showData", { static: true }) showData: TemplateRef<any>;
  selectedRowIndex:any;
  pageEvent: PageEvent;
  showLoader = false;
  fromDate: Date = new Date();
  toDate: Date = new Date();
  displayedColumns = [        
  'sno',
  'gateentry',
  'vehicle_details',
  'customerdetails',
  'carrier',
  'driverdetails',
  // 'yarddetails',
  'material',
  'plantdetails',
  'customerentry',
  'tripdetails',
  'estimateddistance',
  'shipmentdetails',
  // 'action'
]
  // rowDisplayedColumns = ['sno', 'gate_entry_no', 'vehicle_details', 'od_status', 'driver_details']
  closedTripsDetail: any = [];
  closedTripsDetailFilter: any= {
    limit: 0,
    skip: 0,
  };
  totalvehicles = 0;
  carrierId: Subscription;
  reasons: any;
  shipperRemark: any;
  attachedDriver: any;
  dialogRef: any;
  showDialogRef: any;
  currentUnit = true;
  rowData:any;
  odNumber;
  vehicleNumber;
  searchCarrier: any;


  constructor(private http: HttpService, private snackBar: SnackbarService, private events: EventService, private dialog: MatDialog,) { }


  ngOnInit(): void {
    let myCurrentDate = new Date();
    let myPastDate = new Date(myCurrentDate);
    myPastDate.setDate(myPastDate.getDate() - 10);
    this.fromDate = new Date(myPastDate);
    this.toDate = new Date();
    this.getclosedTripsDetails();
    this.carrierId = this.events.getCarrierIdChanges().subscribe(
      (data: any) => {
        this.getclosedTripsDetails();
      }
    );
  }

  getclosedTripsDetails(filter: any = {}) {
    this.showLoader = true;
    filter.limit = this.paginator.pageSize || 200;
    filter.skip = this.paginator.pageIndex * (this.paginator.pageSize || filter.limit);

    filter.from = DateTime.fromJSDate(this.fromDate)
      .startOf("day")
      .toUTC(),
      filter.to = DateTime.fromJSDate(this.toDate).endOf("day").toUTC(),
    filter.all = true;
    if(this.currentUnit){
      filter.all = false;
    }
      this.http.get('closedTripDetails/many', filter, 2).subscribe((data: any) => {
        this.showLoader = false;
        if (data.statusCode === 200) {
          this.closedTripsDetail = data.data.records;
          if (this.closedTripsDetail.length && this.closedTripsDetail.remarks && 
              this.closedTripsDetail.remarks.length) this.closedTripsDetail.remarksJoined = this.closedTripsDetail.remarks.shift().join(', ');
          console.log(this.closedTripsDetail)
          this.totalvehicles = data.data.count;
        }
      }, (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      })
  }

  pageNavigate(event: PageEvent) {
    this.closedTripsDetailFilter.limit = event.pageSize;
    this.closedTripsDetailFilter.skip = event.pageIndex * event.pageSize;
    this.getclosedTripsDetails(this.closedTripsDetailFilter);
  }

  openUpdateRemarks(element) {
    this.shipperRemark = '';
    this.attachedDriver = element.driver;
    this.dialogRef = this.dialog.open(this.addRemarkDialog);
    this.getShipperRemarks();
  }

  getShipperRemarks() {
    this.http.get('constants/get_reasons?name=jsplOBDremarks').subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.reasons = data.data[0].reason;
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    );
  }
  updateRemarks() {
    this.http.post('inPlantVehicles/updateRemarks', { shipper_remark: this.shipperRemark, attached_driver: this.attachedDriver }, 2).subscribe(
      (data: any) => {
        if (data.statusCode === 200) {
          this.snackBar.openSnackBar('Updated successfully');
          this.getclosedTripsDetails();
          this.dialogRef.close();
        }
      },
      (err: any) => {
        this.snackBar.openSnackBar(err.error.message, '', 'err');
      }
    )
  }

  download() {
    let request: any = {};
    if (this.fromDate && this.toDate) {
      const from: any = DateTime.fromJSDate(this.fromDate)
        .startOf("day")
        .toUTC();
      const to: any = DateTime.fromJSDate(this.toDate).endOf("day").toUTC();

      request.from = from.ts;
      request.to = to.ts;
    }
    let url = 'closedTripDetails/all';
    if (this.currentUnit) url = 'closedTripDetails'
    this.http.post("v1/reports/" + url, request, 2).subscribe(
      (response: any) => {

        this.showLoader = false;
        window.open(response.data.link, "_blank");
      },
      (err: any) => {
        this.showLoader = false;
        this.snackBar.openSnackBar(err.error.message, "", "err");
      }
    );
  }
  getOrderStatus (row,i){
    this.selectedRowIndex= i;
    this.rowData=[];
    this.vehicleNumber= row.vehicle;
    this.odNumber = row.od_status || 'N/A';
    const dialogRef = this.dialog.open(JsplDetailsViewComponent, {
      data: this.rowData,
      width: '1250px',
      maxWidth: '95vw !important'
    });
    this.rowData.push(row) ;
  }
  allUnitData(){
    this.currentUnit=!this.currentUnit;
    this.getclosedTripsDetails();
  }

  ngOnDestroy() {
    this.carrierId.unsubscribe();
  }

}
